import {iCrud, iGetData} from "../../model/app/Application";
import {requests} from "../../utils/helpers/api.services";
import {BASE_PATH} from "../../utils/helpers/api.routes";
import {ErrorToast} from "../../utils/toasters/toasters";

export function addLoss(body: iCrud) {
    return requests.post(`${BASE_PATH}/admin/losses`, body)
        .then(data => data)
        .catch(error => ErrorToast(error));
}

export function getLoss(id: number) {
    return requests.get(`${BASE_PATH}/admin/losses/${id}`)
        .then(data => data)
        .catch(error => ErrorToast(error));
}

export function putLoss(id: number, body?: iCrud) {
    return requests.put(`${BASE_PATH}/admin/losses/${id}`, body)
        .then(data => data)
        .catch(error => ErrorToast(error));
}

export function getLosses(body?: iGetData) {
    return requests.get(`${BASE_PATH}/admin/losses`, body)
        .then(data => data)
        .catch(error => ErrorToast(error));
}

export function deleteLoss(id: number) {
    return requests.delete(`${BASE_PATH}/admin/losses/${id}`)
        .then(data => data)
        .catch(error => ErrorToast(error));
}